import { createContext, useMemo, useState } from "react";

export const Context = createContext({});

export const RemainedSecondProvider = ({ children }) => {
  const [remained_second, setRemained_second] = useState(-1);

  let value = useMemo(
    () => ({
      remained_second,
      setRemained_second,
    }),
    [remained_second, setRemained_second]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
